import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceCondition', ['cachedConditions', 'selectedCondition']),
}

export const Methods = mapActions('deviceCondition', [
  'fetchConditions',
  'selectCondition',
  'updateCondition',
])
